import React, {useContext} from "react";
import { AuthContext } from '../../shared/context/auth-context';
import { useHistory } from "react-router-dom";
import Input from "../../shared/components/formElements/Input";
import {
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_REQUIRE,
  VALIDATOR_NUMERIC,
  VALIDATOR_MAX,
  VALIDATOR_SPECIAL_CHARACHTER

} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Button from '../../shared/components/formElements/Button'
import { ITEM_TYPES } from "../components/itemTypes";

import './Items.css'; 
import Capitalize from "../../shared/components/UIElements/Capitalize ";

const NewItem = () => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      style: {
        value: "",
        isValid: false,
      },
      company: {
        value: "",
        isValid: false,
      },
      color: {
        value: "",
        isValid: false,
      },
      USSize: {
        value: "",
        isValid: false,
      },
      EURSize: {
        value: "",
        isValid: true,
      },
      quantity: {
        value: 0,
        isValid: true,
      },
      cost: {
        value: "",
        isValid: true,
      },
      price: {
        value: "",
        isValid: true,
      },
      website: {
        value: "",
        isValid: true,
      }
    },
    false
  );

  const history = useHistory();
  const itemSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/items/new",
        "POST",
        JSON.stringify({
          style: Capitalize(formState.inputs.style.value) + 
          "_"+ Capitalize(formState.inputs.color.value) + 
          "_" + Capitalize(formState.inputs.USSize.value),
          company: Capitalize(formState.inputs.company.value),
          color: Capitalize(formState.inputs.color.value),
          USSize: Capitalize(formState.inputs.USSize.value),
          EURSize: Capitalize(formState.inputs.EURSize.value),
          quantity: formState.inputs.quantity.value,
          cost: formState.inputs.cost.value,
          price: formState.inputs.price.value,
          website: formState.inputs.website.value,
          type: ITEM_TYPES.REGULAR
        }),
        { "Content-Type": "application/json" ,
        Authorization: 'Bearer '+ auth.token}
      );
      history.push("/items");
    } catch (err) {}
  };

  return (
    <React.Fragment>
      
      <ErrorModal error={error} onClear={clearError} />
      <form className="item-form" onSubmit={itemSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h2 className="header-text-Newitem">Create new Item</h2>
        <div className="flex justify-center">
        <div className=" w-50 pa1 mr1">
          <code>
         <Input
          focus="autoFocus"
          id="style"
          element="input" 
          type="text"
          label="Style"
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(23), VALIDATOR_SPECIAL_CHARACHTER()]}
          errorText="Please enter a valid (Less than 20 characters) style."
          onInput={inputHandler}
          />
          </code>
        </div>
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="company"
          element="input"
          type="text"
          label="Company"
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(23), VALIDATOR_SPECIAL_CHARACHTER()]}
          errorText="Please enter a valid (Less than 20 characters) company."
          onInput={inputHandler}
        />
          </code>
        </div>    
      </div>

      <div className="flex justify-center">
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="color"
          element="input"
          type="text"
          label="Color"
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(20), VALIDATOR_SPECIAL_CHARACHTER()]}
          errorText="Please enter less than 20 characters."
          onInput={inputHandler}
        />
          </code>
        </div>
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="quantity"
          element="input"
          type="number"
          label="Quantity"
          /// add validator for numeric entries 
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_NUMERIC(), VALIDATOR_MAX(31)]}
          errorText="Please enter a valid quantity."
          onInput={inputHandler}
          />
          </code>
        </div>    
      </div>
      <div className="flex justify-center">
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="USSize"
          element="input"
          type="text"
          label="US Size"
          validators={[ VALIDATOR_REQUIRE(),
            VALIDATOR_MAXLENGTH(20),
            VALIDATOR_SPECIAL_CHARACHTER()]}
          errorText="Please enter a valid US size."
          onInput={inputHandler}
          />
          </code>
        </div>
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="EURSize"
          element="input"
          type="text"
          label="EUR Size"
          validators={[ VALIDATOR_REQUIRE(),
            VALIDATOR_MAXLENGTH(20),
            VALIDATOR_SPECIAL_CHARACHTER()]}
          errorText="Please enter a valid EUR size."
          onInput={inputHandler}
          />
          </code>
        </div>    
      </div>
      <div className="flex justify-center">
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="cost"
          element="input"
          type="number"
          label="Cost"
          validators={[VALIDATOR_REQUIRE(),VALIDATOR_NUMERIC()]}
          errorText="Please enter a valid cost."
          onInput={inputHandler}
        />
          </code>
        </div>
        <div className=" w-50 pa1 mr1">
          <code>
          <Input
          id="price"
          element="input"
          type="number"
          label="Price"
          validators={[VALIDATOR_REQUIRE(),VALIDATOR_NUMERIC()]}
          errorText="Please enter a valid price."
          onInput={inputHandler}
        />
          </code>
        </div>    
      </div>
        <Input
          id="website"
          element="input"
          type="text"
          label="Website"
          validators={[VALIDATOR_NOT_REQUIRE()]}
          errorText="Please enter a valid Website."
          onInput={inputHandler}
        />
        
        <Button type="submit" disabled={!formState.isValid}>
          ADD ITEM
        </Button>
        <Button inverse to="/items">
          CANCEL
        </Button>
      </form>
    </React.Fragment>
  );
};

export default NewItem;